import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  d: "M13.375 13.65H15.875L16.875 9.15H13.375V7.75C13.375 6.72 13.375 5.75 15.375 5.75H16.875V2.39C16.549 2.347 15.318 2.25 14.018 2.25C11.303 2.25 9.375 3.907 9.375 6.95V9.15H6.375V13.65H9.375V21.75H13.375V13.65Z",
  fill: "#1977F2"
}, null, -1);
const _hoisted_2 = [
  _hoisted_1
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_2);
}
const icV2LogoFacebookColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2LogoFacebookColor as default
};
